/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { ProjectSettingsDetailsConfigProviderEntryEntrypointProps } from './ProjectSettingsDetailsConfigProviderEntry.entrypoint.types.tsx';

type ProjectSettingsDetailsConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	ProjectSettingsDetailsConfigProviderEntryEntrypointProps,
	{} | null
>;

export const projectSettingsDetailsConfigProviderEntrypoint: EntryPoint<
	ProjectSettingsDetailsConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<ProjectSettingsDetailsConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-project-settings-provider" */ './ProjectSettingsDetailsConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
